/**
 * Profile detail component created by karora on 24/06/17.
 */
import 'rxjs/add/operator/switchMap';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AppComponent } from '../app.component';
import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { Programme } from '../types/programme';
import { UserProfile } from '../types/user-profile';


@Component({
  moduleId: module.id,
  selector: 'profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.css'],
  providers: [VoxPopService],
})

export class ProfileDetailComponent implements OnInit {
  CanAdminister = ProfileService.CanAdministerAll;
  CanAdministerProgramme = ProfileService.CanAdministerProgramme;
  profile: UserProfile;
  programmes = <Programme[]>[];
  errorMessage: string;

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;

    this.voxPopService.myActiveProgrammes().subscribe(
      programmes => {
        this.programmes = programmes;
        console.log("Programmes: " + JSON.stringify(programmes, null, 2));
      },
      error => this.errorMessage = <any>error,
    );

    console.log("Getting profile detail.");
    this.route.params
      .switchMap((params: Params) => this.voxPopService.getProfile(params['profiletype'], params['profileid']))
      .subscribe(
        profile => this.setProfile(profile),
        error => this.errorMessage = <any>error,
      );
  }

  setProfile(profile: UserProfile) {
    console.log("Loaded profile " + profile.social.name + "(" + profile.id + ")");
    if (!profile.programme_rights) {
      profile.programme_rights = <Map<number, string>>{};
    }

    this.profile = profile;
    AppComponent.SetTitle(profile.social.name)
  }

  toggleAdminister(pID: number): void {
    let currentUserProfile = ProfileService.CurrentUserProfile();
    if (pID < 1) {
      if (currentUserProfile.id === this.profile.id) {
        alert("You can't change your own rights!")
        return;
      } else {
        if (this.CanAdminister()) {
          this.profile.administer = !this.profile.administer;
        } else {
          alert("You do not have global administrator rights!");
          return;
        }
      }
    } else {
      if (currentUserProfile.id === this.profile.id && !this.CanAdminister()) {
        alert("You can't change your own rights!")
        return;
      } else {
        let rights: string = this.profile.programme_rights[pID];
        let newRights = "";
        if (rights && rights.length && rights.indexOf("r") >= 0) {
          newRights = "r";
        }
        if (!rights || !rights.length || rights.indexOf("A") < 0) {
          newRights += "A"
        }
        this.profile.programme_rights[pID] = newRights;
      }
    }
    this.updateProfile();
  }

  toggleReview(pID: number): void {
    let currentUserProfile = ProfileService.CurrentUserProfile();
    if (pID < 1) {
      if (currentUserProfile.id === this.profile.id) {
        alert("You can't change your own rights!")
        return;
      } else {
        if (this.CanAdminister()) {
          this.profile.review = !this.profile.review;
        } else {
          alert("You do not have global administrator rights!");
          return;
        }
      }
    } else {
      if (currentUserProfile.id === this.profile.id && !this.CanAdminister()) {
        alert("You can't change your own rights!")
        return;
      } else {
        let rights: string = this.profile.programme_rights[pID];
        let newRights = "";
        if (rights && rights.length && rights.indexOf("A") >= 0) {
          newRights = "A";
        }
        if (!rights || !rights.length || rights.indexOf("r") < 0) {
          newRights += "r"
        }
        this.profile.programme_rights[pID] = newRights;
      }
    }
    this.updateProfile();
  }

  Reviewable(pID: number): boolean {
    let rights: string = this.profile.programme_rights[pID];
    if (rights && rights.length && rights.indexOf("r") >= 0) {
      return true;
    }
    return false;
  }

  Adminable(pID: number): boolean {
    if (!this.profile.programme_rights) return false;
    let rights: string = this.profile.programme_rights[pID];
    if (rights && rights.length && rights.indexOf("A") >= 0) {
      return true;
    }
    return false;
  }

  ImageSource(type: string, pID: number, prog: Programme): string {
    // console.log("Programme: " + JSON.stringify(prog, null, 2));
    if ((type === "review" && this.Reviewable(pID)) || (type === "admin" && this.Adminable(pID))) return "/images/confirm.svg";
    return "/images/cancel.svg";
  }

  updateProfile() {
    this.voxPopService.updateProfile(this.profile)
      .subscribe(
        profile => this.setProfile(profile),
        error => this.errorMessage = <any>error,
      );
  }
}
